module.exports = __webpack_public_path__ + "img/lesson_03.13cf31fe.jpg";